import React, { useEffect, useState } from "react";
import "../css/main.scss";
import { STORE_CONFIG } from "../config/storeConfig";

const carouselImages = ["/main/hero-01.png", "/main/hero-02.png"];
const projects = [
  ["/main/story-01.png", "The everyday crossbody"],
  ["/main/story-02.png", "Open weave for lighter days"],
  ["/main/story-03.png", "Soft leather, close at hand"],
  ["/main/story-04.png", "A small bag for city hours"],
  ["/main/story-05.png", "From shoulder bag to evening"],
  ["/main/story-06.png", "Workday organisation"],
  ["/main/story-07.png", "Lightweight weekend carry"],
  ["/main/story-08.png", "Packed for a short journey"],
  ["/main/story-09.png", "Shape, seam and proportion"],
  ["/main/story-10.png", "Compact pieces for essentials"],
  ["/main/story-11.png", "Leather, canvas and nylon"],
  ["/main/story-12.png", "Carry into the evening"],
];

function Main() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => setCurrentSlide((slide) => (slide + 1) % carouselImages.length), 5000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="main"><main>
      <section className="hero-section" aria-label="Featured bags">
        <div className="carousel-container">
          {carouselImages.map((img, index) => <div key={img} className={`carousel-slide ${index === currentSlide ? "active" : ""}`} aria-hidden={index !== currentSlide}><img src={img} alt={index === 0 ? "Unbranded leather bags arranged in a quiet studio" : "Canvas and nylon bags prepared for an urban day"} /></div>)}
          <div className="carousel-dots" aria-label="Choose hero image">{carouselImages.map((img, index) => <button key={img} type="button" className={`dot ${index === currentSlide ? "active" : ""}`} aria-label={`Show image ${index + 1}`} aria-current={index === currentSlide} onClick={() => setCurrentSlide(index)} />)}</div>
        </div>
      </section>
      <section className="intro-section">
        <h2>BAGS FOR THE RHYTHM OF EVERY DAY</h2>
        <p>{STORE_CONFIG.brand} is a {STORE_CONFIG.operatingRegion} bag store focused on crossbody bags, totes, shoulder bags, work bags, backpacks and compact travel pieces.</p>
        <p>We choose useful proportions, clear compartments and tactile materials—bags designed around what people actually carry rather than borrowed status symbols.</p>
        <p>Every product page explains capacity, dimensions, main materials, carrying options and the care each surface needs.</p>
        <div className="divider-dots" aria-hidden="true">······················</div>
      </section>
      <section className="brands-section">
        <p>LEATHER · CANVAS · NYLON · WOVEN COTTON · SATIN · PRACTICAL HARDWARE</p><hr />
        <p>Original bag imagery, precise dimensions and practical care guidance for considered everyday carry.</p>
      </section>
      <section className="projects-section">
        <h3>TWELVE WAYS TO CARRY THE DAY</h3>
        <div className="projects-grid">{projects.map(([img, title]) => <article key={img} className="project-item"><div className="img-box"><img src={img} alt={title} loading="lazy" /></div><p>{title}</p></article>)}</div>
      </section>
    </main></div>
  );
}

export default Main;
